// @flow

import React, { Component } from "react"
import styled from "styled-components"
import _ from "lodash"
import _Checkbox from "react-toolbox/lib/checkbox/Checkbox"

const Root = styled.div`
  margin-left: 80px;
  margin-right: 80px;
  transition: max-height 0.3s;
  max-height: 0px;
  overflow: hidden;
  ${ props => props.expanded ? "max-height: 1000px;" : "" }

  @media (max-width: 800px) {
    margin-left: 10px;
    margin-right: 10px;
  }
`

const CheckboxWrapper = styled.div`
  padding-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const Element = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  cursor: pointer;
`

const Expander = styled.div`
  flex: 1;
`

const Checkbox = styled( _Checkbox )`
  &>div {
      border-color: #FFF !important;
      border-radius: 1px;
      background-color: #FFF !important;
  }
  &>span {
      color: #FFF;
  }
  ${ props => props.checked ? `
    &>div {
      border-color: #FFF;
      background-color: #FFF;
    }
    &>div:after {
        border-color: #2196f3 !important;
    }
  ` : "" }
`

export const CONFIG_TABLE = [
  { injunctionId: "N° Injução",
    executionLot: "Lote Execução",
    id: "ID CASO" },

  { court: "Tribunal",
    processId: "N° Processo",
    type: "Tipo",
    subType: "Sub tipo" },

  { procedurePhase: "Fase processual",
    state: "Estado",
    subState: "Sub estado" },

  { nif: "NIF",
    name: "Nome",
    debtValue: "Valor Dívida",
    clientName: "Cliente" },
]

export default class ConfigContainer extends Component {
  props: {
    value: [],
    onChange: ( k: string | number, v: string ) => {},
    expanded: boolean,
  }

  renderElement = ( value: any, key: number ) => {
    let checked = this.props.value[ key ]
    return (
      <Element key={key}>
        <Checkbox
          checked={checked}
          label={value}
          onChange={( v ) => this.props.onChange( key, v )}
        />
        <Expander />
      </Element>
    )
  }

  renderOption = ( element: any, index: number ) => {
    return (
      <Column key={index}>
        {_.map( element, this.renderElement )}
      </Column>
    )
  }

  render () {
    const { expanded, value } = this.props
    if ( value === undefined ) {
      return ( <div /> )
    }

    return (
      <Root expanded={expanded}>
        <CheckboxWrapper>
          {_.map( CONFIG_TABLE, this.renderOption )}
        </CheckboxWrapper>
      </Root>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfigContainer.jsx